import * as React from 'react';

import BaseInfluencerAgencyPage from 'modules/influencers-agency/pages/BaseInfluencerAgencyPage';
import InfluencersAgencyOverview from '../components/influencers-agency-overview/InfluencersAgencyOverview';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../influencers-agencies-pages.i18n.json'));

import { Params } from 'types';

type OwnProps = {
  params: Params
};

type Props = OwnProps;

const InfluencersAgencyProfilesOverviewPage = ({ params }: Props) => {
  const agencyId = Number(params.id);

  return (
    <BaseInfluencerAgencyPage
      agencyId={agencyId}
      documentTitle={__t('influencers_agencies_pages.profiles_overview_heading')}
    >
      <InfluencersAgencyOverview
        agencyId={agencyId}
      />
    </BaseInfluencerAgencyPage>
  );
};

export default InfluencersAgencyProfilesOverviewPage;
